import {useState, useContext, useEffect} from 'react';
import {LoaderContext} from "../../../../../context/LoaderContext.jsx";
import {deleteBatchApi, getBatchApi} from "../../../../../services/SchedulazioniServices";

export const useTabellaBatch = () => {

    const [loadingData, setLoadingData] = useState(true);
    const [batch, setBatch] = useState([]);
    const [batchSel, setBatchSel] = useState(null);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    const deleteBatch = async () => {
        setShowConfirmDelete(false);
        startChiamata();
        const response = await deleteBatchApi(batchSel.id_batch);
        if (parseInt(response.data.result) === -1) {
            setModalMsg(response.data.description);
            setShow(true);
        } else {
            setBatch(response.data.data);
        }
        endChiamata();
    }

    const getBatch = async () => {
        startChiamata();
        const response = await getBatchApi();
        setBatch(response.data.data);
        setLoadingData(false);
        endChiamata();
    }

    useEffect(() => {
        getBatch();
    }, []);

    const closeModal = () => setShow(false);

    const funzioneFiltro = (item, filtro) => {
        return (item.codice && item.codice.toLowerCase().includes(filtro.toLowerCase()))
            || (item.descrizione && item.descrizione.toLowerCase().includes(filtro.toLowerCase()))
    }

    return {
        loadingData,
        batch,
        batchSel,
        setBatchSel,
        showConfirmDelete,
        setShowConfirmDelete,
        deleteBatch,
        modalMsg,
        closeModal,
        show,
        funzioneFiltro,
    };
};
